// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IRequestPesquisaCita, DataPesquisaCITA, Types } from './types';

export function pesquisaCITAAACRequest(
	token: string,
	payload: IRequestPesquisaCita,
): ReducerActionRotaSP {
	return {
		type: Types.PESQUISA_CITA_AAC_REQUEST,
		token,
		payload,
	};
}

export function pesquisaCITAAACSuccess(
	payload: DataPesquisaCITA,
): ReducerActionRotaSP {
	return {
		type: Types.PESQUISA_CITA_AAC_SUCCESS,
		payload,
	};
}

export function pesquisaCITAAACFailure(): ReducerActionRotaSP {
	return {
		type: Types.PESQUISA_CITA_AAC_FAILURE,
		payload: null,
	};
}

export function limpaPesquisaCITAAAC(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_PESQUISA_CITA_AAC,
		payload: null,
	};
}
